module.exports = __webpack_public_path__ + "img/renaissance_cleaning_services_10.a6b77cb2.jpg";